// API configuration
export const API_BASE_URL = import.meta.env.DEV
  ? 'http://localhost:3001'
  : 'https://podcast-insights-worker.dipanshu-gupta.workers.dev'; 